import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { FarmerOrder } from 'types/farmerOrder'
import { EntityMetadata } from 'modules/domain/types'

const dict = (state: AppGlobalState) => state.farmerOrder.items
const ids = (state: AppGlobalState) => state.farmerOrder.ids
const item = (state: AppGlobalState, id: string): FarmerOrder | undefined => state.farmerOrder.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<FarmerOrder> =>
  state.farmerOrder.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.farmerOrder.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.farmerOrder.listFetchProgress
const listFetchError = (state: AppGlobalState) => state.farmerOrder.listFetchError
const listFetchNextProgress = (state: AppGlobalState) => state.farmerOrder.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.farmerOrder.listFetchNextError
const list = createSelector(dict, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: FarmerOrder[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.farmerOrder.filter
const sorting = (state: AppGlobalState) => state.farmerOrder.sorting
const page = (state: AppGlobalState) => state.farmerOrder.page
const total = (state: AppGlobalState) => state.farmerOrder.total
const totalQty = (state: AppGlobalState) => state.farmerOrder.totalQty
const totalDeliveredQty = (state: AppGlobalState) => state.farmerOrder.totalDeliveredQty
const totalFinalQty = (state: AppGlobalState) => state.farmerOrder.totalFinalQty
const updateProgress = (state: AppGlobalState) => state.farmerOrder.updateProgress
const updateError = (state: AppGlobalState) => state.farmerOrder.updateError
const removeProgress = (state: AppGlobalState) => state.farmerOrder.removeProgress
const addProgress = (state: AppGlobalState) => state.farmerOrder.addProgress
const hasNext = (state: AppGlobalState) => state.farmerOrder.total > state.farmerOrder.ids.length
const pageSize = (state: AppGlobalState) => state.farmerOrder.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.farmerOrder.total / state.farmerOrder.pageSize)
const newOrdersCount = (state: AppGlobalState) => state.farmerOrder.newOrdersCount
const newOrdersCountProgress = (state: AppGlobalState) => state.farmerOrder.newOrdersCountProgress

const FarmerOrderSelectors = {
  filter,
  sorting,
  page,
  total,
  totalQty,
  totalDeliveredQty,
  totalFinalQty,
  updateProgress,
  removeProgress,
  addProgress,
  item,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  list,
  dict,
  ids,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  pages,
  newOrdersCount,
  newOrdersCountProgress,
  updateError,
}

export default FarmerOrderSelectors
